export default __webpack_public_path__ + "static/media/no_image.48983953.svg";